import React from "react";
import Loadable from "react-loadable";
import { reloadOnChunkError } from "./_services/chunkReload";

function Loading(props) {
    if (props.error && !reloadOnChunkError(props.error)) {
        return (
            <div className="text-center p-4">
                <p>Die Seite konnte nicht geladen werden.</p>
                <button className="btn btn-primary" onClick={() => window.location.reload()}>
                    Seite neu laden
                </button>
            </div>
        );
    }
    return <div></div>;
}

const ChargebeeImport = Loadable({
    loader: () => import("./integrations/billing/Chargebee/screens/ChargebeeImportScreen"),
    loading: Loading,
});
const ChargebeeIntegrations = Loadable({
    loader: () => import("./integrations/billing/Chargebee/screens/ChargebeeIntegrationsScreen"),
    loading: Loading,
});

const StripeBillingImport = Loadable({
    loader: () => import("./integrations/billing/StripeBilling/screens/StripeBillingImportScreen"),
    loading: Loading,
});

const StripeBillingIntegrations = Loadable({
    loader: () => import("./integrations/billing/StripeBilling/screens/StripeBillingIntegrationsScreen"),
    loading: Loading,
});

const User = Loadable({
    loader: () => import("./user/screens/User"),
    loading: Loading,
});

const Help = Loadable({
    loader: () => import("./commons/screens/Help"),
    loading: Loading,
});

const Home = Loadable({
    loader: () => import("./home/HomeScreen"),
    loading: Loading,
});

const Clients = Loadable({
    loader: () => import("./organization/client/screens/ClientsScreen"),
    loading: Loading,
});

const MyOrganization = Loadable({
    loader: () => import("./organization/myOrganization/screens/MyOrganization"),
    loading: Loading,
});

const StripePaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/StripePayments/screens/StripePaymentsIntegrationScreen"),
    loading: Loading,
});
const StripePaymentsImportScreen = Loadable({
    loader: () => import("./integrations/payment/StripePayments/screens/StripePaymentsImportScreen"),
    loading: Loading,
});

const GoCardlessIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/GoCardless/screens/GoCardlessIntegrationScreen"),
    loading: Loading,
});

const GoCardlessImportScreen = Loadable({
    loader: () => import("./integrations/payment/GoCardless/screens/GoCardlessImportScreen"),
    loading: Loading,
});

const LexOfficeDashboard = Loadable({
    loader: () => import("./integrations/LexOffice/screens/LexOfficeDashboard"),
    loading: Loading,
});

const LexOfficeRegistration = Loadable({
    loader: () => import("./integrations/LexOffice/screens/LexOfficeRegistration"),
    loading: Loading,
});

const LexOfficeAutoLogin = Loadable({
    loader: () => import("./integrations/LexOffice/screens/LexOfficeAutoLogin"),
    loading: Loading,
});

const LexOfficeOrganizationSettings = Loadable({
    loader: () => import("./integrations/LexOffice/screens/LexOfficeOrganizationSettings"),
    loading: Loading,
});

const AdyenIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/Adyen/screens/AdyenIntegrationScreen.js"),
    loading: Loading,
});

const AdyenImportScreen = Loadable({
    loader: () => import("./integrations/payment/Adyen/screens/AdyenImportScreen.js"),
    loading: Loading,
});

const AmazonPayIntegrations = Loadable({
    loader: () => import("./integrations/Amazon/Pay/screens/AmazonPayIntegrations"),
    loading: Loading,
});

const AmazonPayV2Integrations = Loadable({
    loader: () => import("./integrations/payment/AmazonPay/screens/AmazonPayV2IntegrationScreen"),
    loading: Loading,
});

const AmazonPayV2ImportScreen = Loadable({
    loader: () => import("./integrations/payment/AmazonPay/screens/AmazonPayV2ImportScreen"),
    loading: Loading,
});

const PayPalIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/PayPal/screens/PaypalIntegrationScreen"),
    loading: Loading,
});

const PayPalImportScreen = Loadable({
    loader: () => import("./integrations/payment/PayPal/screens/PaypalImportScreen"),
    loading: Loading,
});

const KlarnaIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/Klarna/screens/KlarnaIntegrationScreen"),
    loading: Loading,
});

const KlarnaImportScreen = Loadable({
    loader: () => import("./integrations/payment/Klarna/screens/KlarnaImportScreen"),
    loading: Loading,
});

const MollieIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/Mollie/screens/MollieIntegrationScreen"),
    loading: Loading,
});

const MollieImportScreen = Loadable({
    loader: () => import("./integrations/payment/Mollie/screens/MollieImportScreen"),
    loading: Loading,
});

const TikTokPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/TikTokPayments/screens/TikTokPaymentsIntegrationScreen"),
    loading: Loading,
});

const TikTokPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/payment/TikTokPayments/screens/TikTokPaymentsImportScreen"),
    loading: Loading,
});

const EbayIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/eBay/screens/EbayIntegrationScreen"),
    loading: Loading,
});

const ZalandoImportScreen = Loadable({
    loader: () => import("./integrations/shop/Zalando/screens/ZalandoImportScreen"),
    loading: Loading,
});

const ZalandoIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Zalando/screens/ZalandoIntegrationScreen"),
    loading: Loading,
});

const EbayImportScreen = Loadable({
    loader: () => import("./integrations/shop/eBay/screens/EbayImportScreen"),
    loading: Loading,
});

const EbayPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/eBay/payments/screens/EbayPaymentsIntegrationScreen"),
    loading: Loading,
});

const EbayPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/shop/eBay/payments/screens/EbayPaymentsImportScreen"),
    loading: Loading,
});

const KauflandIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Kaufland/screens/KauflandIntegrationScreen"),
    loading: Loading,
});

const KauflandImportScreen = Loadable({
    loader: () => import("./integrations/shop/Kaufland/screens/KauflandImportScreen"),
    loading: Loading,
});

const KauflandPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Kaufland/payments/screens/KauflandPaymentsIntegrationScreen"),
    loading: Loading,
});

const KauflandPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/shop/Kaufland/payments/screens/KauflandPaymentsImportScreen"),
    loading: Loading,
});

const OttoIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Otto/screens/OttoIntegrationScreen"),
    loading: Loading,
});

const OttoImportScreen = Loadable({
    loader: () => import("./integrations/shop/Otto/screens/OttoImportScreen"),
    loading: Loading,
});

const OttoPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Otto/payments/screens/OttoPaymentsIntegrationScreen"),
    loading: Loading,
});

const OttoPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/shop/Otto/payments/screens/OttoPaymentsImportScreen"),
    loading: Loading,
});

const ZalandoPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/Zalando/payments/screens/ZalandoPaymentsIntegrationScreen"),
    loading: Loading,
});

const ZalandoPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/shop/Zalando/payments/screens/ZalandoPaymentsImportScreen"),
    loading: Loading,
});

const TikTokShopIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/TikTokShop/screens/TikTokShopIntegrationScreen"),
    loading: Loading,
});

const TikTokShopImportScreen = Loadable({
    loader: () => import("./integrations/shop/TikTokShop/screens/TikTokShopImportScreen"),
    loading: Loading,
});

const AboutYouIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/AboutYou/screens/AboutYouIntegrationScreen"),
    loading: Loading,
});

const AboutYouImportScreen = Loadable({
    loader: () => import("./integrations/shop/AboutYou/screens/AboutYouImportScreen"),
    loading: Loading,
});

const AboutYouPaymentsIntegrationScreen = Loadable({
    loader: () => import("./integrations/shop/AboutYou/payments/screens/AboutYouPaymentsIntegrationScreen"),
    loading: Loading,
});

const AboutYouPaymentsImportScreen = Loadable({
    loader: () => import("./integrations/shop/AboutYou/payments/screens/AboutYouPaymentsImportScreen"),
    loading: Loading,
});

const UnzerIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/Unzer/screens/UnzerIntegrationScreen"),
    loading: Loading,
});

const UnzerImportScreen = Loadable({
    loader: () => import("./integrations/payment/Unzer/screens/UnzerImportScreen"),
    loading: Loading,
});

const ShopifyPaymentsImport = Loadable({
    loader: () => import("./integrations/payment/ShopifyPayments/screens/ShopifyPaymentsImportScreen"),
    loading: Loading,
});

const ShopifyPaymentsIntegrations = Loadable({
    loader: () => import("./integrations/payment/ShopifyPayments/screens/ShopifyPaymentsIntegrationScreen"),
    loading: Loading,
});

const ShopifyPosImport = Loadable({
    loader: () => import("./integrations/payment/ShopifyPos/screens/ShopifyPosImportScreen"),
    loading: Loading,
});

const ShopifyPosIntegrations = Loadable({
    loader: () => import("./integrations/payment/ShopifyPos/screens/ShopifyPosIntegrationScreen"),
    loading: Loading,
});

const AmazonPayoutIntegrations = Loadable({
    loader: () => import("./integrations/Amazon/Payout/screens/AmazonPayoutIntegrationsScreen"),
    loading: Loading,
});

const AmazonPayoutIntegrationsImport = Loadable({
    loader: () => import("./integrations/Amazon/Payout/screens/AmazonPayoutImportScreen"),
    loading: Loading,
});

const AmazonOrderImportScreen = Loadable({
    loader: () => import("./integrations/shop/AmazonOrder/screens/AmazonOrderImportScreen"),
    loading: Loading,
});

const AmazonOrderIntegrations = Loadable({
    loader: () => import("./integrations/shop/AmazonOrder/screens/AmazonOrderIntegrationsScreen"),
    loading: Loading,
});

const AmazonAccountingPreview = Loadable({
    loader: () => import("./integrations/Amazon/AmazonAccountingMarketingScreen"),
    loading: Loading,
});

const BambooIntegrations = Loadable({
    loader: () => import("./integrations/Bamboo/screens/BambooIntegrations"),
    loading: Loading,
});

const HRChangeReportList = Loadable({
    loader: () => import("./integrations/HRChangeReport/screens/HRChangeReportList"),
    loading: Loading,
});

const HRChangeReport = Loadable({
    loader: () => import("./integrations/HRChangeReport/screens/HRChangeReport"),
    loading: Loading,
});

const BambooDatevSettings = Loadable({
    loader: () => import("./integrations/Bamboo/screens/BambooDatevSettings"),
    loading: Loading,
});

const ShopifyInformation = Loadable({
    loader: () => import("./integrations/shop/Shopify/components/ShopifyInformation"),
    loading: Loading,
});

const ShopifyIntegrations = Loadable({
    loader: () => import("./integrations/shop/Shopify/Order/screens/ShopifyIntegrationScreen"),
    loading: Loading,
});

const ShopifyImportScreen = Loadable({
    loader: () => import("./integrations/shop/Shopify/Order/screens/ShopifyImportScreen"),
    loading: Loading,
});

const ShopwareIntegrations = Loadable({
    loader: () => import("./integrations/Shopware/screens/ShopwareIntegrationsScreen"),
    loading: Loading,
});

const ShopwareImportScreen = Loadable({
    loader: () => import("./integrations/Shopware/screens/ShopwareImportScreen"),
    loading: Loading,
});

const OSSDashboard = Loadable({
    loader: () => import("./features/OSSDashboard/screens/OSSDashboard"),
    loading: Loading,
});

const WooCommerceIntegrations = Loadable({
    loader: () => import("./integrations/shop/WooCommerce/screens/WooCommerceIntegrationScreen"),
    loading: Loading,
});

const WooCommerceIntegrationsImport = Loadable({
    loader: () => import("./integrations/shop/WooCommerce/screens/WooCommerceImportScreen"),
    loading: Loading,
});

const BambooReport = Loadable({
    loader: () => import("./integrations/Bamboo/screens/BambooReport"),
    loading: Loading,
});

const AccountingTasks = Loadable({
    loader: () => import("./features/AccountingTasks/screens/AccountingTasks"),
    loading: Loading,
});

const AccountingTaskDetails = Loadable({
    loader: () => import("./features/AccountingTasks/screens/AccountingTaskDetails"),
    loading: Loading,
});

const AdminArea = Loadable({
    loader: () => import("./admin/screens/AdminArea"),
    loading: Loading,
});

const UserAdmin = Loadable({
    loader: () => import("./admin/screens/UserAdmin.js"),
    loading: Loading,
});

const OrganizationAdmin = Loadable({
    loader: () => import("./admin/screens/OrganizationAdmin.js"),
    loading: Loading,
});

const LogoutScreen = Loadable({
    loader: () => import("./user/screens/LogoutScreen"),
    loading: Loading,
});

const ConverterOverview = Loadable({
    loader: () => import("./features/Converter/screens/ConverterOverview"),
    loading: Loading,
});

const SnipcartIntegrations = Loadable({
    loader: () => import("./integrations/SnipCart/screens/SnipcartIntegrationsScreen"),
    loading: Loading,
});

const SnipcartIntegrationsImport = Loadable({
    loader: () => import("./integrations/SnipCart/screens/SnipcartImportsScreen"),
    loading: Loading,
});

const StoreganiseIntegrations = Loadable({
    loader: () => import("./integrations/Storeganise/screens/StoreganiseIntegrationsScreen"),
    loading: Loading,
});

const StoreganiseIntegrationsImport = Loadable({
    loader: () => import("./integrations/Storeganise/screens/StoreganiseImportScreen"),
    loading: Loading,
});

const BraintreeIntegrationScreen = Loadable({
    loader: () => import("./integrations/payment/Braintree/screens/BraintreeIntegrationScreen"),
    loading: Loading,
});
const BraintreeImportScreen = Loadable({
    loader: () => import("./integrations/payment/Braintree/screens/BraintreeImportScreen"),
    loading: Loading,
});

const PathwayBilling = Loadable({
    loader: () => import("./integrations/PaythwayBilling/screens/PathwayBilling"),
    loading: Loading,
});

const PaymentsMatching = Loadable({
    loader: () => import("./features/PaymentsMatching/screens/PaymentsMatching"),
    loading: Loading,
});

const FileDownloadScreen = Loadable({
    loader: () => import("./features/FileDownloads/screens/FileDownloadsScreen"),
    loading: Loading,
});

const AddIntegrationsScreen = Loadable({
    loader: () => import("./features/AddIntegrations/screens/AddIntegrationsScreen"),
    loading: Loading,
});

//https:github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
    { path: "/help", name: "Hilfe", component: Help },
    { path: "/user", name: "Profil", component: User },
    { path: "/dologout", name: "Logout", component: LogoutScreen },
    { path: "/onboarding", name: "Home", component: Home },
    {
        path: "/information/shopify",
        name: "Shopify",
        component: ShopifyInformation,
    },

    { path: "/clients", name: "Shops & Accounts", component: Clients },
    { path: "/organization", name: "Organisation", component: MyOrganization },

    {
        path: "/lexoffice/register",
        name: "LexOffice Registration",
        component: LexOfficeRegistration,
    },
    {
        path: "/lexoffice/autologin",
        name: "LexOffice Autologin",
        component: LexOfficeAutoLogin,
    },
    {
        path: "/lexoffice-settings",
        name: "LexOffice Settings",
        component: LexOfficeOrganizationSettings,
    },
    {
        path: "/lexoffice",
        name: "LexOffice Dashboard",
        component: LexOfficeDashboard,
    },

    {
        path: "/integrations/braintree/:id",
        name: "Braintree Import",
        component: BraintreeImportScreen,
    },
    {
        path: "/integrations/braintree",
        name: "Braintree",
        component: BraintreeIntegrationScreen,
    },

    {
        path: "/integrations/gocardless/:id",
        name: "GoCardless Import",
        component: GoCardlessImportScreen,
    },
    {
        path: "/integrations/gocardless",
        name: "GoCardless",
        component: GoCardlessIntegrationScreen,
    },

    {
        path: "/integrations/klarna/:id",
        name: "Klarna Import",
        component: KlarnaImportScreen,
    },
    {
        path: "/integrations/klarna",
        name: "Klarna",
        component: KlarnaIntegrationScreen,
    },

    {
        path: "/integrations/mollie/:id",
        name: "Mollie Import",
        exact: true,
        component: MollieImportScreen,
    },
    {
        path: "/integrations/mollie",
        name: "Mollie",
        exact: true,
        component: MollieIntegrationScreen,
    },

    {
        path: "/integrations/ebay/payments/:id",
        name: "eBay Payments Import",
        exact: true,
        component: EbayPaymentsImportScreen,
    },
    {
        path: "/integrations/ebay/payments",
        name: "eBay Payments",
        exact: true,
        component: EbayPaymentsIntegrationScreen,
    },
    {
        path: "/integrations/ebay/:id",
        name: "eBay Import",
        exact: true,
        component: EbayImportScreen,
    },
    {
        path: "/integrations/ebay",
        name: "eBay",
        exact: true,
        component: EbayIntegrationScreen,
    },

    {
        path: "/integrations/kaufland/payments/:id",
        name: "Kaufland Payments Import",
        exact: true,
        component: KauflandPaymentsImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/kaufland/payments",
        name: "Kaufland Payments",
        exact: true,
        component: KauflandPaymentsIntegrationScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/kaufland/:id",
        name: "Kaufland Import",
        exact: true,
        component: KauflandImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/kaufland",
        name: "Kaufland",
        exact: true,
        component: KauflandIntegrationScreen,
        superUserOnly: true,
    },

    {
        path: "/integrations/otto/payments/:id",
        name: "Otto Payments Import",
        exact: true,
        component: OttoPaymentsImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/otto/payments",
        name: "Otto Payments",
        exact: true,
        component: OttoPaymentsIntegrationScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/otto/:id",
        name: "Otto Import",
        exact: true,
        component: OttoImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/otto",
        name: "Otto",
        exact: true,
        component: OttoIntegrationScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/zalando/payments/:id",
        name: "Zalando Zahlungen Import",
        exact: true,
        component: ZalandoPaymentsImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/zalando/payments",
        name: "Zalando Zahlungen",
        exact: true,
        component: ZalandoPaymentsIntegrationScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/zalando/:id",
        name: "Zalando Import",
        exact: true,
        component: ZalandoImportScreen,
        superUserOnly: true,
    },
    {
        path: "/integrations/zalando",
        name: "Zalando",
        exact: true,
        component: ZalandoIntegrationScreen,
        superUserOnly: true,
    },

    {
        path: "/integrations/tiktok/payments/:id",
        name: "TikTok Payments Import",
        exact: true,
        component: TikTokPaymentsImportScreen,
    },
    {
        path: "/integrations/tiktok/payments",
        name: "TikTok Payments",
        exact: true,
        component: TikTokPaymentsIntegrationScreen,
    },

    {
        path: "/integrations/tiktok/shop/:id",
        name: "TikTok Shop Import",
        exact: true,
        component: TikTokShopImportScreen,
    },
    {
        path: "/integrations/tiktok/shop",
        name: "TikTok Shop",
        exact: true,
        component: TikTokShopIntegrationScreen,
    },

    {
        path: "/integrations/aboutyou/payments/:id",
        name: "About You Payments Import",
        exact: true,
        component: AboutYouPaymentsImportScreen,
    },
    {
        path: "/integrations/aboutyou/payments",
        name: "About You Payments",
        exact: true,
        component: AboutYouPaymentsIntegrationScreen,
    },

    {
        path: "/integrations/aboutyou/:id",
        name: "About You Import",
        exact: true,
        component: AboutYouImportScreen,
    },
    {
        path: "/integrations/aboutyou",
        name: "About You",
        exact: true,
        component: AboutYouIntegrationScreen,
    },

    {
        path: "/integrations/unzer/:id",
        name: "Unzer Import",
        exact: true,
        component: UnzerImportScreen,
    },
    {
        path: "/integrations/unzer",
        name: "Unzer",
        exact: true,
        component: UnzerIntegrationScreen,
    },

    {
        path: "/integrations/paypal/:id",
        name: "PayPal Import",
        component: PayPalImportScreen,
    },
    {
        path: "/integrations/paypal",
        name: "PayPal",
        component: PayPalIntegrationScreen,
    },

    {
        path: "/integrations/stripe/payments/:id",
        name: "Stripe Payments Import",
        component: StripePaymentsImportScreen,
    },
    {
        path: "/integrations/stripe/payments",
        name: "Stripe Payments",
        component: StripePaymentsIntegrationScreen,
    },
    {
        path: "/integrations/adyen/:id",
        name: "Adyen",
        component: AdyenImportScreen,
    },
    {
        path: "/integrations/adyen",
        name: "Adyen",
        exact: true,
        component: AdyenIntegrationScreen,
    },
    {
        path: "/integrations/amazon/overview",
        name: "Amazon Buchhaltungsexport",
        exact: true,
        component: AmazonAccountingPreview,
    },
    {
        path: "/integrations/amazon/pay/v2/:id",
        name: "Amazon Pay import",
        exact: false,
        component: AmazonPayV2ImportScreen,
    },
    {
        path: "/integrations/amazon/pay/v2",
        name: "Amazon Pay",
        exact: true,
        component: AmazonPayV2Integrations,
    },
    {
        path: "/integrations/amazon/pay/v1",
        name: "Amazon Pay",
        exact: true,
        component: AmazonPayIntegrations,
    },
    {
        path: "/integrations/hrchanges",
        name: "HR Reports",
        component: HRChangeReportList,
    },
    {
        path: "/integrations/hrchangereport/:id",
        name: "HR Report",
        component: HRChangeReport,
    },
    {
        path: "/integrations/hrchangereport",
        name: "HR Report",
        component: HRChangeReport,
    },
    {
        path: "/integrations/bamboo/datevsettings",
        exact: true,
        name: "Datev Einstellungen",
        component: BambooDatevSettings,
    },
    {
        path: "/integrations/bamboo",
        exact: true,
        name: "Bamboo",
        component: BambooIntegrations,
    },
    {
        path: "/integrations/bambooresult",
        name: "Bamboo Report",
        component: BambooReport,
    },
    {
        path: "/integrations/chargebee/:id",
        name: " Chargebee Import",
        component: ChargebeeImport,
    },
    { path: "/integrations/chargebee", name: "Chargebee", component: ChargebeeIntegrations },

    { path: "/integrations/oss", name: "OSS Dashboard", component: OSSDashboard },

    {
        path: "/integrations/shopify/import/:id",
        name: "Shopify Umsatzimport",
        component: ShopifyImportScreen,
    },
    {
        path: "/integrations/shopify/import",
        name: "Shopify Umsatzimport",
        exact: true,
        component: ShopifyImportScreen,
    },
    {
        path: "/integrations/shopify/payments/:id",
        name: "Shopify Payments",
        component: ShopifyPaymentsImport,
    },
    {
        path: "/integrations/shopify/payments",
        name: "Shopify Payments",
        exact: true,
        component: ShopifyPaymentsIntegrations,
    },
    {
        path: "/integrations/shopify/pos/:id",
        name: "Shopify POS",
        component: ShopifyPosImport,
    },
    {
        path: "/integrations/shopify/pos",
        name: "Shopify POS",
        exact: true,
        component: ShopifyPosIntegrations,
    },
    {
        path: "/integrations/shopify",
        name: "Shopify",
        exact: true,
        component: ShopifyIntegrations,
    },
    {
        path: "/integrations/shopware/import/:id",
        name: "Shopware Umsatzimport",
        component: ShopwareImportScreen,
    },
    {
        path: "/integrations/shopware/import/",
        name: "Shopware Umsatzimport",
        component: ShopwareImportScreen,
    },
    {
        path: "/integrations/shopware",
        name: "Shopware",
        component: ShopwareIntegrations,
    },
    {
        path: "/integrations/stripe/billing/:id",
        name: " Stripe Billing Import",
        component: StripeBillingImport,
    },
    {
        path: "/integrations/stripe/billing",
        name: "Stripe Billing",
        component: StripeBillingIntegrations,
    },
    {
        path: "/integrations/snipcart/import/:id",
        name: "Snipcart Import",
        component: SnipcartIntegrationsImport,
    },
    {
        path: "/integrations/snipcart/import",
        name: "Snipcart Import",
        component: SnipcartIntegrationsImport,
    },
    {
        path: "/integrations/snipcart",
        name: "Snipcart",
        component: SnipcartIntegrations,
    },

    {
        path: "/integrations/storeganise/import/:id",
        name: "Storeganise Import",
        component: StoreganiseIntegrationsImport,
    },
    {
        path: "/integrations/storeganise/import",
        name: "Storeganise Import",
        component: StoreganiseIntegrationsImport,
    },
    {
        path: "/integrations/storeganise",
        name: "Storeganise",
        component: StoreganiseIntegrations,
    },
    {
        path: "/integrations/amazon/payout/import/:id",
        name: "Amazon Payout Import",
        component: AmazonPayoutIntegrationsImport,
    },
    {
        path: "/integrations/amazon/payout",
        name: "Amazon Payout",
        component: AmazonPayoutIntegrations,
    },

    {
        path: "/integrations/amazon/order/import/:id",
        name: "Amazon Order Import",
        component: AmazonOrderImportScreen,
    },
    {
        path: "/integrations/amazon/order",
        name: "Amazon Order",
        component: AmazonOrderIntegrations,
    },
    {
        path: "/integrations/woocommerce/:id",
        name: "WooCommerce Umsatzimport",
        component: WooCommerceIntegrationsImport,
    },
    {
        path: "/integrations/woocommerce",
        name: "WooCommerce",
        component: WooCommerceIntegrations,
    },
    {
        path: "/system/buchungsstapel/:id",
        name: "Buchungsvorgang",
        component: AccountingTaskDetails,
    },
    {
        path: "/system/buchungsstapel",
        name: "Buchungsstapel",
        component: AccountingTasks,
    },
    {
        path: "/adminarea/organization/:id",
        name: "Details",
        component: OrganizationAdmin,
    },
    {
        path: "/adminarea/organization",
        name: "Organisation",
        component: OrganizationAdmin,
    },
    { path: "/adminarea/user/:id", name: "Benutzer", component: UserAdmin },

    { path: "/adminarea/:module", name: undefined, component: AdminArea },

    { path: "/adminarea", name: "Administration", component: AdminArea },

    { path: "/addintegrations", name: "Weitere Integrationen", component: AddIntegrationsScreen },

    {
        path: "/converter/overview",
        name: "Converter",
        component: ConverterOverview,
    },
    {
        path: "/billing/pathway",
        name: "pathway Rechnungsprinter",
        component: PathwayBilling,
    },
    {
        path: "/paymentsmatching",
        name: "Payments Matching Engine",
        component: PaymentsMatching,
    },
    {
        path: "/system/files",
        name: "Dateien",
        component: FileDownloadScreen,
    },
    // { path: "/integrations", exact: false, name: "Home", component: Home },
    { path: "/", exact: true, name: "Home", component: Home },
];

export default routes;
